export const FIELDS = {

  ID: 'id',
  WORKFLOW_ITEM_ID: 'workflowItemId',
  SODATE: 'soDate',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  BILL_TO: 'billTo',
  SHIP_TO: 'shipTo',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  BILLING_TERM_ID: 'billingTermId',
  COMMENTS: 'comments',
  INTERNAL_COMMENTS: 'internalComments',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  TAX_NUMBER: 'taxNumber',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  SHIPPING_CHARGES: 'shippingCharges',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TAX: 'tax',
  TOTAL: 'total',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  GROSS_PROFIT: 'grossProfit',
  GPMARGIN: 'gpMargin',
  ATTENTION: 'attention',
  CUSTOMER_PO: 'customerPo',
  SHIP_ON_VENDOR_ACCOUNT: 'shipOnVendorAccount',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  STATUS_ID: 'statusId',
  SALES_TYPE_ID: 'salesTypeId',
  INCO_TYPE_ID: 'incoTypeId',
  RISK_ASSESSMENT_TYPE_ID: 'riskAssessmentTypeId',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  DATE_EMAILED: 'dateEmailed',
  ON_HOLD: 'onHold',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SONO: 'soNo',
  COMPANY_NAME: 'companyName',
  CONTACT_FIRST_NAME: 'contactFirstName',
  CONTACT_LAST_NAME: 'contactLastName',
  CONTACT_FULL_NAME: 'contactFullName',
  STATUS_NAME: 'statusName',
  BILLING_TERM_NAME: 'billingTermName',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  WORKFLOW_ITEM_NAME: 'workflowItemName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SALES_TYPE_NAME: 'salesTypeName',
  SORT_ORDER: 'sortOrder',
  LINE_COUNT: 'lineCount',
  TOTAL_QUANTITY: 'totalQuantity',
  TOTAL_COST: 'totalCost',
  TOTAL_PRICE: 'totalPrice',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  EXPR1: 'expr1',
  INCO_TYPE_NAME: 'incoTypeName',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  SHIPPING_NOTES: 'shippingNotes',
  NAME: 'name',
  REQUIREMENT_NUMBER: 'requirementNumber',
  PREFIX: 'prefix',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  CUSTOMER_PN: 'customerPN',
  DESCRIPTION: 'description',
  MFG_NAME: 'mfgName',
  QUANTITY: 'quantity',
  PRICE: 'price',
  CONDITION_NAME: 'conditionName',
  REQUIREMENT_FAX: 'requirementFax',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  NEED_BY_DATE: 'needByDate',
  TESTING_REQUESTED: 'testingRequested',
  VENDOR_NOTE: 'vendorNote',
  LEAD_FREE: 'leadFree',
  TEMP_RATING: 'tempRating',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  REQUIREMENT_ID: 'requirementId',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CONDITION_ID: 'conditionId',
  MANUFACTURER_ID: 'manufacturerId',
  SCHEDULE_B: 'scheduleB',
  ECCN: 'eccn',
  HARMONIZED_CODE: 'harmonizedCode',
  NSN_NUMBER: 'nsnNumber',
  ALT_NUMBER: 'altNumber',
  INTERNAL_PN: 'internalPN',
  REFERAL_SOURCE_ID: 'referalSourceId',
  CUSTOMER_NOTE: 'customerNote',
  BUY_PRICE: 'buyPrice',
  REQUIREMENT_DATE: 'requirementDate',
  SPQ: 'piecePerPkg',
  PHYS_PKG: 'physPkg',
  UOM_ID: 'uoMId',
  UOM: 'uom',
  PART_COMMENTS: 'partComments',
  COST: 'cost',
  SKU: 'sku',
  CLASS_NAME: 'className',
  CATEGORY_NAME: 'categoryName',
  PIECE_PER_PKG: 'piecePerPkg',
  MOQ: 'moq',
  WARRANTY_ID: 'warrantyId',
  WARRANTY_NAME: 'warrantyName',
  VENDOR_WARRANTY_ID: 'vendorWarrantyId',
  VENDOR_WARRANTY_NAME: 'vendorWarrantyName',
  CUSTOMER_DELIVERY: 'customerDelivery',
  VENDOR_DELIVERY: 'vendorDelivery',
  REFERAL_SOURCE_NAME:'referalSourceName'

};